import { Button, Modal } from 'react-bootstrap';
import { Shipping_Detail__c_Update } from './shipDetailReset.interfaces';

interface ShipDetailResetConfirmProps {
  shipDetail: Shipping_Detail__c_Update
  modalVisible: boolean
  closeModal: any
  title: string
  handleConfirm: any
}

export default function ShipDetailResetConfirm(props: ShipDetailResetConfirmProps){
  const {shipDetail: sd} = props

  function formatContent(content: any){
    return content === null ? <span style={{color: 'green'}}>CLEAR OUT</span> : typeof content === 'undefined' ? <span style={{color: 'orange'}}>NO CHANGE</span> : <span style={{color: 'green'}}>{content}</span>
  }

  return <Modal show={props.modalVisible} animation={false} onHide={props.closeModal} className='modal-xl'>
  <Modal.Header 
    closeButton
    style={{ 
      position: 'sticky', 
      top: -1, 
      zIndex: 1050, 
      backgroundColor: 'white', 
      borderBottom: '1px solid #ddd'
    }}
  >
    <Modal.Title>
      <span className='beacon-header'>{props.title}</span>
    </Modal.Title>
  </Modal.Header>
    
  <Modal.Body>
    <div style={{fontSize: 'larger'}}>
      <span className='beacon-label' style={{color: 'black'}}>SALESFORCE ID: {sd?.Id}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>AZURE STATUS: {formatContent(sd?.Azure_Status__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>BATCH NAME: {formatContent(sd?.BatchName__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>FULFILLMENT SOFTWARE ID: {formatContent(sd?.ShipStation_Order_Id__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>FULFILLED BY SOFTWARE: {formatContent(sd?.Fulfilled_by_Software__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>INVOICE UPLOADED TIME: {formatContent(sd?.Invoice_Uploaded_Time__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>SHIPMENT SENT TIME: {formatContent(sd?.Shipment_Sent_Time__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>SHIPMENT TIME: {formatContent(sd?.Shipment_Time__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>SHIPMENT UPLOADED TIME: {formatContent(sd?.Shipment_Uploaded_Time__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>CARRIER: {formatContent(sd?.Shipping_Carrier__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>CLASS: {formatContent(sd?.Shipping_Class__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>STATUS: {formatContent(sd?.Shipping_Status_Calc__c)}</span>
      <br/><span className='beacon-label' style={{color: 'black'}}>TRACKING NUMBER: {formatContent(sd?.Tracking_Number__c)}</span>

    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant='success' onClick={props.handleConfirm}>CONFIRM</Button>
    <Button variant='secondary' onClick={props.closeModal}>CLOSE</Button>
  </Modal.Footer>
</Modal>
}